import { useCallback, useEffect, useMemo, useState } from "react";
import { FetcherWithComponents, useNavigation } from "react-router-dom";
import { getErrorFromFetcherData } from "utils/fetcherUtils";


export function useCallbackAfterSubmission(
  callback?: () => void,
  fetcher?: FetcherWithComponents<any>,
  isSuccessfullySubmittedCallback?: () => boolean,
  checkSuccessfulSubmission: boolean = true,
) {
  const navigation = useNavigation();

  const [ oldState, setOldState ] = useState<FetcherWithComponents<any>["state"]>();

  const currentState = useMemo(() => {
    return fetcher?.state ?? navigation.state;
  }, [ fetcher, navigation ]);

  const wasSuccessfulCallback = useCallback(() => {
    if (isSuccessfullySubmittedCallback) {
      return isSuccessfullySubmittedCallback();
    }

    if (fetcher) {
      return (fetcher.data !== undefined) && (getErrorFromFetcherData(fetcher) === undefined);
    }

    return false;
  }, [ isSuccessfullySubmittedCallback, fetcher ]);

  useEffect(() => {
    if (callback) {
      if (oldState === "submitting") {
        // have to wait for the fetcher to go idle after submission, otherwise some hooks depending on it can return the "optimistic" data which got submitted,
        // resulting in false-positive success detections here
        if (currentState === "idle") {
          if (!checkSuccessfulSubmission || wasSuccessfulCallback()) {
            callback();
          }
          setOldState(currentState);
        }
      } else {
        setOldState(currentState);
      }
    }
  }, [ callback, oldState, currentState, checkSuccessfulSubmission, wasSuccessfulCallback ]);
}
